import { render } from "./PracticeTestList.vue?vue&type=template&id=3dbf192c&scoped=true"
import script from "./PracticeTestList.vue?vue&type=script&lang=js"
export * from "./PracticeTestList.vue?vue&type=script&lang=js"

import "./PracticeTestList.vue?vue&type=style&index=0&id=3dbf192c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbf192c"]])

export default __exports__